<template lang="pug">
section(:id='swiperid')
  .product-carousel-header.d-flex.justify-content-between
    h3.m-0 {{ title }}
    .swiper-control.d-flex.align-items-center
      .swiper-pagination.position-relative
      .swiper-prev.navigation
      .swiper-next.navigation
  swiper(ref='swiper', :options='swiperOptions')
    swiper-slide.product-col.h-100(v-for='item in value', :key='item.id')
      product-item(:item='item')
</template>

<script>
import ProductItem from './ProductItem.vue'

export default {
  components: { ProductItem },

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      default: '',
    },

    swiperid: {
      type: String,
      default: '',
      require: true,
    },
  },

  data() {
    return {
      swiperOptions: {
        // autoplay: {
        //   delay: 5000,
        // },
        // preloadImages: false,
        // lazy: true,
        loop: false,
        speed: 800,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        navigation: {
          nextEl: `#${this.swiperid} .swiper-next`,
          prevEl: `#${this.swiperid} .swiper-prev`,
        },
        pagination: {
          el: `#${this.swiperid} .swiper-pagination`,
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navigation {
  height: 5px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  cursor: pointer;
  margin-left: 8px;

  &.swiper-prev {
    border-right: 8px solid var(--bs-blue);
  }

  &.swiper-next {
    border-left: 8px solid var(--bs-blue);
  }
}
.swiper-pagination {
  ::v-deep {
    .swiper-pagination-bullet {
      margin: 0 2px -1px;
    }
  }
}
.product-carousel-header {
  color: #000;
  padding: 0.5rem 1rem 0.5rem 2rem;
  background: #fff;
  border-bottom: solid 1px #eee;

  @media (max-width: 575px) {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  h3 {
    font-size: 1.75rem;

    @media (max-width: 575px) {
      font-size: 1.25rem;
    }
  }
}
section {
  ::v-deep {
    .product-title a {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
  }
}
</style>
